// GlobalStyle.ts
import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  p, div, th, td, li, a, h1, h2, h3, h4, h5, h6, button, input, textarea, .ant-form-item-label > label, .ant-input, .ant-modal-title, input.ant-input {
    font-size: 18px;
  }
`

export default GlobalStyle
